export const TEXT_AREA_STATUS = {
  default: 'default',
  success: 'success',
  error: 'error',
  primary: 'primary'
};
